<template>
  <b-modal
      id="user-delete-modal"
      :title="'Supprimer ' + $t('a.user')"
      @ok="handleOk"
      :ok-title="$t('Delete')"
      ok-variant="danger"
      :cancel-title="$t('Cancel')"
      cancel-variant="danger"
  >
    <div v-if="selectedUser !== null">
      {{ $t('Delete') }} {{ $t('l.user') }} "{{ selectedUser.username }}" ?
    </div>
  </b-modal>
</template>

<script>

import api from '../../services/api';

export default {

  name: 'UserDeleteModal',

  props: {
    selectedUser: Object
  },

  emits: ['didDeleteUser'],


  methods: {

    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault() // Prevent modal from closing
      this.handleSubmit()
    },

    handleSubmit() {
      let username = this.selectedUser.username

      api
          .delete(`/user/${this.selectedUser.id}`)
          .then(response => {
            this.$emit('didDeleteUser')
            this.hideModal()
            this.successToast(this.$i18n.t('User') + ' "' + username + '" ' + this.$i18n.t('deleted'))
          })
          .catch((error) => {
            if (error.response.status === 418) {
              this.$bvToast.toast(error.response.data.message, {
                autoHideDelay: 2000,
                toaster: 'b-toaster-bottom-right'
              })
            }
          });
    },

    hideModal() {
      this.$bvModal.hide('user-delete-modal')
    },

    successToast(message) {
      this.$bvToast.toast(message, {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/user/UserDeleteModal.vue